import { useState } from 'react'
import {
  useQuery,
} from '@tanstack/react-query';
import { postMemberEnrollment } from '../../../../lib/api';
import { captureError } from '../../../../lib/sentry';
import Text from '../../../ui/text';

function EndCover(props) {
  const { data } = props;
  const [allowSubmit, setAllowSubmit] = useState(true);

  const { isPending, isError,  data: record, error } = useQuery({
    queryKey: ['postMemberEnrollment', JSON.stringify(data)],
    queryFn: async () => {
      try {
        const response = await postMemberEnrollment(data);
        setAllowSubmit(false);
        return response;
      } catch (error) {
        // Capturar el error en Sentry
        captureError(error, { component: 'member-enrollment-end-cover', query: 'postMemberEnrollment' });
        throw error; // Relanzar el error para que React Query lo maneje
      }
    },
    enabled: !!data?.signature && allowSubmit,
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false
  });

  return (
    <main className="w-full flex flex-col pt-10 gap-5 sm:gap-10">
      <div className='w-full text-center'>
        <span className='w-full text-gray-600 text-center text-2xl font-bold'><Text>You have completed the Enrollment Application for</Text></span>
      </div>
      <div className='w-full flex flex-row justify-center'>
        <div className='w-full flex flex-col max-w-lg bg-gray-50 text-center'>
          <div className='p-5 bg-[#ffefea] font-bold text-lg text-primary'>{data?.planName}</div>
          <div className='px-5 py-10 h-auto flex flex-col sm:flex-row text-base text-gray-600 items-center gap-5'>
            {isPending ? (
              <div className='flex-1 flex flex-col'>
                <Text>Loading...</Text>
              </div>
            ) : (
              <>
                <div className='flex-1 flex flex-col'>
                  <div><Text>Confirmation Number</Text></div>
                  <div className='text-gray-700 font-bold'>{record?.success ? record?.data?.confirmationNumber || null : <Text>ERROR</Text>}</div>
                </div>
                <div className='flex-1 flex flex-col'>
                  <div><Text>Application Date</Text></div>
                  <div className='text-gray-700 font-bold'>{record?.success ? record?.data?.applicationDate || null : <Text>ERROR</Text>}</div>
                </div>
              </>
            )}
            
          </div>
        </div>
      </div>
      <div className='w-full text-gray-600 text-center text-base'>
        <div className='max-w-3xl mx-auto'>
          <Text interpolation={{ planName: data?.planName }} children={`You'll get a letter from us with an enrollment decision. Once the Centers for Medicare & Medicaid (CMS) approve your application, you will be enrolled in {{planName}}. If you have any questions regarding your enrollment, contact Member Services at`} /><a href='tel:+18444476547' className='text-primary'> 844-447-6547 (<Text>TTY</Text>: 711)</a>.
        </div>
      </div>
    </main>
  );
}

export default EndCover;